export default __webpack_public_path__ + "static/media/error-outline-icon.a83f4aae.svg";